// require("moment")
window.moment = require('moment');
require('moment-timezone')
require("tempusdominus-bootstrap-4")

// $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
//   icons: {
//     time: 'far fa-clock',
//     date: 'far fa-calendar-alt',
//     up: 'fas fa-arrow-up',
//     down: 'fas fa-arrow-down',
//     previous: 'fas fa-chevron-left',
//     next: 'fas fa-chevron-right',
//     today: 'far fa-calendar-check-o',
//     clear: 'far fa-trash',
//     close: 'far fa-times'
//   }
// });

function initMyDatetimePickers() {
  "use strict"; // Start of use strict

  const datePickerOpts = {
    format: 'DD-MM-YYYY',
    showToday: true,
    locale: 'en' // https://github.com/moment/moment/tree/develop/locale
  };

  const timePickerOpts = {
    format: 'HH:mm',
    stepping: 5,
    showToday: true,
    locale: 'en' // https://github.com/moment/moment/tree/develop/locale
  };

  const datetimePickerOpts = {
    format: 'DD-MM-YYYY HH:mm',
    stepping: 5,
    showToday: true,
    locale: 'en' // https://github.com/moment/moment/tree/develop/locale
  };

  // console.log('initMyDatetimePickers');
  $('.datepicker').datetimepicker(datePickerOpts);
  $('.timepicker').datetimepicker(timePickerOpts);
}

document.addEventListener("turbolinks:load", () => {
  initMyDatetimePickers();
})

export {initMyDatetimePickers};
